import { useQuery } from "@tanstack/react-query";
import { axios } from "@/client/libs/axios";
import { AxiosResponse } from "axios";
import { FilterReferenceUser, ReferenceUser } from "@reactive-resume/dto";
import qs from "qs";

const reference = async (page: number, filter?: FilterReferenceUser | null) => {
  if (filter) {
    const response = await axios.get<
      ReferenceUser,
      AxiosResponse<{ page: number; data: ReferenceUser[] }>
    >(`references/`, {
      params: {
        page: page,
        ...filter,
      },
      paramsSerializer: (params) => {
        let query = qs.stringify(params);
        console.log(query);
        return query;
      },
    });
    console.log(response.data);
    return response.data;
  }
  const response = await axios.get<
    ReferenceUser,
    AxiosResponse<{ page: number; data: ReferenceUser[] }>
  >(`references/`, {
    params: {
      page: page,
    },
  });
  return response.data;
};

export const useReferences = (page: number, filter?: FilterReferenceUser | null) => {
  const {
    data: references,
    isPending: loading,
    error,
  } = useQuery({
    queryKey: ["references", page, filter],
    queryFn: () => reference(page, filter),
  });
  return { references, loading, error };
};
